import { render, staticRenderFns } from "./AgendadorTarefaComponent.vue?vue&type=template&id=a404902e&"
import script from "./AgendadorTarefaComponent.vue?vue&type=script&lang=js&"
export * from "./AgendadorTarefaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports